import api from "../Api";
import { BaseService } from "../BaseService";

const URL = "dashboards/productivity";

export class ProductivityDashboardService extends BaseService {
  async getKpis(params: any = {}): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/kpis`, { params }));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getSessions(params: any = {}): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/sessions`, { params }));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getMaterials(params: any = {}): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/materials`, { params }));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getRanking(params: any = {}): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/ranking`, { params }));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getPeakHours(params: any = {}): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/peak-hours`, { params }));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getCategories(params: any = {}): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/categories`, { params }));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getQualityCorrections(params: any = {}): Promise<any> {
    try {
      return this.handleResponse(await api.get("dashboards/quality/corrections", { params }));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getQualityRanking(params: any = {}): Promise<any> {
    try {
      return this.handleResponse(await api.get("dashboards/quality/ranking", { params }));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
